import { useMemo } from 'react';
import { useAuthContext } from '@/contexts/AuthContext';
import { gruposLiberados, type GatesUsuario, type GrupoRelatorios } from '@/config/relatorios';

/**
 * Os relatórios que o usuário logado pode abrir, já agrupados.
 *
 * Uma leitura só das flags do `/auth/me/` serve o menu lateral e a home — assim as
 * duas nunca discordam sobre o que aparece.
 */
export function useRelatorios(): { grupos: GrupoRelatorios[]; gates: GatesUsuario } {
  const { user } = useAuthContext();
  const gates = useMemo<GatesUsuario>(
    () => ({ dashboard: user?.dashboard_feature_enabled, seop: user?.seop_feature_enabled }),
    [user?.dashboard_feature_enabled, user?.seop_feature_enabled],
  );
  const grupos = useMemo(() => gruposLiberados(gates), [gates]);
  return { grupos, gates };
}
